module.exports = __webpack_public_path__ + "src/assets/images/hero-pro-beta-logo-red.png?a2145e1030dfed81408bf7391ff0545a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hero-pro-beta-logo-red.png
// module id = 992
// module chunks = 1